import { Button, Grid } from "@material-ui/core";
import { GridColDef } from "@material-ui/data-grid";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { useVendorsContext } from "../../../context/VendorsContext";

type Props = {
	setModalEditDataVendor: Function;
	setModalDeleteVendor: Function;
	setVendorIdForEdit: Function;
	setVendorIdForDelete: Function;
};
export const useTableData = ({
	setVendorIdForEdit,
	setModalEditDataVendor,
	setVendorIdForDelete,
	setModalDeleteVendor,
}: Props) => {
	const { state } = useVendorsContext();

	const columns: GridColDef[] = [
		{
			field: "vendorId",
			headerName: " ",
			sortable: true,
			width: 0,
		},
		{
			field: "vendorName",
			headerName: "Name",
			sortable: false,
			flex: 1,
		},
		{
			field: "nsblVendorId",
			headerName: "NSBL Vendor Id",
			sortable: true,
			flex: 1,
		},
		{
			field: "isActive",
			headerName: "Status",
			sortable: true,
			flex: 1,
		},
		{
			field: "Actions",
			renderCell: (params) => {
				return (
					<Grid
						container
						justifyContent="center"
						alignItems="center"
						spacing={1}
						style={{ padding: "0" }}
					>
						<Grid item md={6} xs={6} style={{ padding: "0", marginLeft: -25 }}>
							<Button
								fullWidth
								onClick={() => {
									(async () => {
										setVendorIdForEdit(params.row.vendorId);
										setModalEditDataVendor(true);
									})();
								}}
							>
								<EditIcon style={{ width: 16, height: 16 }} color="primary" />
							</Button>
						</Grid>
						<Grid item md={6} xs={6} style={{ padding: "0" }}>
							<Button
								fullWidth
								onClick={() => {
									(async () => {
										setVendorIdForDelete(params.row.vendorId);
										setModalDeleteVendor(true);
									})();
								}}
							>
								<DeleteIcon
									style={{ width: 16, height: 16 }}
									color="secondary"
								/>
							</Button>
						</Grid>
					</Grid>
				);
			},
			headerName: " ",
			sortable: false,
		},
	];

	const rows = state.vendors.map(
		({ vendorId, vendorName, nsblVendorId, isActive }) => {
			return {
				vendorId,
				vendorName,
				nsblVendorId,
				isActive: isActive ? "Active" : "Inactive",
				id: vendorId,
			};
		},
	);

	return { rows, columns };
};
